import { init as initApm } from '@elastic/apm-rum'

const apm = initApm({
    serviceName: 'cms-frontend',
    serverUrl: 'https://dgto-apm.ugems.id',
    environment: 'production'
})

export default apm
